module.exports = __webpack_public_path__ + "static/tu-raj-kare-655e9ca2dd69db747fecf15056bdf512.jpg";